import React from "react";
import { Menu, MenuItem, MenuLabel } from "../components/Menu";
import ExportText from "./ExportText";
import ExportJSON from "./ExportJSON";
import ExportWebpage from "./ExportWebpage";
import { consoleOnAtom, bugReportOnAtom } from "../jotai/atoms";
import { useAtom } from "jotai";
import ArchiveSpace from "./ArchiveSpace";
import { useAuth } from "../auth/useAuth";
import Icon from "../components/Icon";
import { generatenewSpaceId } from "./Home";
import { logOut } from "./LogOutButton";
import { useHistory } from "react-router-dom";

export default function Overflow() {
  const [consoleOn, setConsoleOn] = useAtom(consoleOnAtom);
  const [bugReportOn, setBugReportOn] = useAtom(bugReportOnAtom);
  const { auth } = useAuth();
  const history = useHistory();

  return (
    <>
      <Menu icon="Menu" ariaLabel="Menu">
        {auth && (
          <>
            <MenuLabel>Menu</MenuLabel>

            <MenuItem
              onSelect={() => {
                const newSpaceId = generatenewSpaceId();
                history.push("/space/" + newSpaceId);
              }}
            >
              <Icon icon="Plus" />
              New space
            </MenuItem>
            <MenuItem
              onSelect={() => {
                logOut(window.location.pathname);
              }}
            >
              <Icon icon="Leave" />
              Log out
            </MenuItem>
          </>
        )}
        {/* <MenuLabel>Advanced options</MenuLabel> */}
        <MenuItem onSelect={() => setBugReportOn(!bugReportOn)}>
          Write Feedback!
        </MenuItem>
        <ExportWebpage />
        <ExportText />
        <ExportJSON />

        <MenuItem onSelect={() => setConsoleOn(!consoleOn)}>
          Experiments panel
        </MenuItem>

        <ArchiveSpace />
        <MenuItem
          onSelect={() => {
            history.push("/spaces/");
          }}
        >
          <Icon icon="More" />
          Browse Recent Spaces
        </MenuItem>
      </Menu>
    </>
  );
}
